/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import {
  retrieveLaborTimeGuideEndPoint,
  getsLaborTimeGuideDetailEndPoint,
} from '../common/constants';
import {
  sendRequestAndReceiveResponse,
  filterNames,
  filterModels,
} from '../common/common';

const LOADING_LABORTIMEGUIDE_DETAIL = 'LOADING_LABORTIMEGUIDE_DETAIL';
const LOAD_LABORTIMEGUIDE = 'LOAD_LABORTIMEGUIDE';
const LABORTIMEGUIDE_DETAIL = 'LABORTIMEGUIDE_DETAIL';
const CLEAR_VIEW_LABORTIMEGUIDE_STORE = 'CLEAR_VIEW_LABORTIMEGUIDE_STORE';
const UPDATE_SERIAL_NUMBER = 'UPDATE_SERIAL_NUMBER';
const STOP_LOADING = 'STOP_LOADING';
const CLEAR_LABORTIMEGUIDES_LIST = 'CLEAR_LABORTIMEGUIDES_LIST';
const UPDATE_FAMILIES = 'UPDATE_FAMILIES';
const UPDATE_SELECTED_FAMILY = 'UPDATE_SELECTED_FAMILY';
const UPDATE_SELECTED_PRODUCTNAME = 'UPDATE_SELECTED_PRODUCTNAME';
const UPDATE_SELECTED_PRODUCTMODEL = 'UPDATE_SELECTED_PRODUCTMODEL';
const UPDATE_PRODUCTNAMES = 'UPDATE_PRODUCTNAMES';
const UPDATE_PRODUCTMODELS = 'UPDATE_PRODUCTMODELS';
const UPDATE_ALL_CLASSIFICATION = 'UPDATE_ALL_CLASSIFICATION';
const SERVICE_LABORTIMEGUIDE_DATA = 'SERVICE_LABORTIMEGUIDE_DATA';
const UN_SELECT_LABORTIMEGUIDE = 'UN_SELECT_LABORTIMEGUIDE';
const UPDATE_SELECTED_LABORTIMEGUIDE_IDS = 'UPDATE_SELECTED_LABORTIMEGUIDE_IDS';

const initialState = {
  data: {},
  families: [],
  productNames: [],
  productModels: [],
  serialNumber: '',
};

export const actionCreators = {
  UpdateSelectedFamily:
    (selectedFamilies: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_SELECTED_FAMILY, selectedFamilies });
      const labortimeguideData = await sendRequestAndReceiveResponse(
        JSON.stringify({
          ClassificationId: selectedFamilies[0],
          ClassificationType: 'productfamily',
        }),
        retrieveLaborTimeGuideEndPoint
      );
      dispatch({ type: SERVICE_LABORTIMEGUIDE_DATA, labortimeguideData });
    },
  UpdateSelectedProductName:
    (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_SELECTED_PRODUCTNAME, SelectedProductNames });
      const labortimeguideData = await sendRequestAndReceiveResponse(
        JSON.stringify({
          ClassificationId: SelectedProductNames[0],
          ClassificationType: 'productname',
        }),
        retrieveLaborTimeGuideEndPoint
      );
      dispatch({ type: SERVICE_LABORTIMEGUIDE_DATA, labortimeguideData });
    },
  UpdateSelectedProductModel:
    (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_SELECTED_PRODUCTMODEL, SelectedProductModels });
      const labortimeguideData = await sendRequestAndReceiveResponse(
        JSON.stringify({
          ClassificationId: SelectedProductModels[0],
          ClassificationType: 'productmodel',
        }),
        retrieveLaborTimeGuideEndPoint
      );
      dispatch({ type: SERVICE_LABORTIMEGUIDE_DATA, labortimeguideData });
    },
  selectLaborTimeGuide: (data: any) => async (dispatch: any, getState: any) => {
    dispatch({ type: LOADING_LABORTIMEGUIDE_DETAIL });
    const selectedLaborTimeGuide = await sendRequestAndReceiveResponse(
      JSON.stringify({
        LaborTimeGuideId: data.LaborTimeGuideId,
      }),
      getsLaborTimeGuideDetailEndPoint
    );
    dispatch({ type: LABORTIMEGUIDE_DETAIL, selectedLaborTimeGuide });
  },
  unselectLaborTimeGuide: () => async (dispatch: any, getState: any) => {
    dispatch({ type: UN_SELECT_LABORTIMEGUIDE });
  },
  updatedSelectedId:
    (selectedIds: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_SELECTED_LABORTIMEGUIDE_IDS, selectedIds });
    },

  UpdateProductClassificationonSerialNumber:
    (
      selectedFamily: any,
      selectedProductName: any,
      selectedProductModel: any,
      labortimeguideData: any
    ) =>
    async (dispatch: any, getState: any) => {
      dispatch({
        type: UPDATE_ALL_CLASSIFICATION,
        selectedFamily,
        selectedProductName,
        selectedProductModel,
        labortimeguideData,
      });
    },
  FilterNames:
    (Productfamilies: any, selectedProductFamily: any) =>
    async (dispatch: any, getState: any) => {
      let productNames: any = [];
      productNames = filterNames(Productfamilies, selectedProductFamily);
      dispatch({ type: UPDATE_PRODUCTNAMES, productNames });
    },
  FilterModels:
    (ProductNames: any, selectedProductName: any) =>
    async (dispatch: any, getState: any) => {
      let productModels: any = [];
      productModels = filterModels(ProductNames, selectedProductName);
      dispatch({ type: UPDATE_PRODUCTMODELS, productModels });
    },
  UpdateProductFamilies:
    (families: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_FAMILIES, families });
    },
  LoadLaborTimeGuide:
    (serialNumber: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: LOAD_LABORTIMEGUIDE, serialNumber });
    },
  UpdateSerialNumber:
    (serialNumber: any) => async (dispatch: any, getState: any) => {
      dispatch({ type: UPDATE_SERIAL_NUMBER, serialNumber });
    },
  StopLoading: () => async (dispatch: any, getState: any) => {
    dispatch({ type: STOP_LOADING });
  },
  ClearViewLaborTimeGuideData: () => async (dispatch: any, getState: any) => {
    dispatch({ type: CLEAR_VIEW_LABORTIMEGUIDE_STORE });
  },
  ClearLaborTimeGuideList: () => async (dispatch: any, getState: any) => {
    dispatch({ type: CLEAR_LABORTIMEGUIDES_LIST });
  },
};

export const reducer = (state: any, action: any) => {
  state = state || initialState;

  switch (action.type) {
    case UPDATE_SELECTED_FAMILY:
      return {
        ...state,
        selectedFamily: action.selectedFamilies,
        selectedProductName: undefined,
        selectedProductModel: undefined,
        isLaborTimeGuideLoading: true,
        selectedLaborTimeGuide: undefined,
        selectedLaborTimeGuideIds: undefined,
        serialNumber: '',
      };
    case UPDATE_SELECTED_PRODUCTNAME:
      return {
        ...state,
        selectedProductName: action.SelectedProductNames,
        selectedProductModel: undefined,
        isLaborTimeGuideLoading: true,
        selectedLaborTimeGuide: undefined,
        selectedLaborTimeGuideIds: undefined,
        serialNumber: '',
      };
    case UPDATE_SELECTED_PRODUCTMODEL:
      return {
        ...state,
        selectedProductModel: action.SelectedProductModels,
        isLaborTimeGuideLoading: true,
        selectedLaborTimeGuide: undefined,
        selectedLaborTimeGuideIds: undefined,
        serialNumber: '',
      };
    case SERVICE_LABORTIMEGUIDE_DATA:
      return {
        ...state,
        isLaborTimeGuideLoading: false,
        labortimeguideData: action.labortimeguideData,
      };
    case LOADING_LABORTIMEGUIDE_DETAIL:
      return {
        ...state,
        loadingLaborTimeGuideDetail: true,
      };
    case LABORTIMEGUIDE_DETAIL:
      return {
        ...state,
        loadingLaborTimeGuideDetail: false,
        selectedLaborTimeGuide: action.selectedLaborTimeGuide,
      };
    case UN_SELECT_LABORTIMEGUIDE:
      return {
        ...state,
        selectedLaborTimeGuide: undefined,
      };
    case UPDATE_SELECTED_LABORTIMEGUIDE_IDS:
      return {
        ...state,
        selectedLaborTimeGuideIds: action.selecteddIds,
      };

    case UPDATE_ALL_CLASSIFICATION:
      return {
        ...state,
        selectedFamily: action.selectedFamily,
        selectedProductName: action.selectedProductName,
        selectedProductModel: action.selectedProductModel,
        labortimeguideData: action.labortimeguideData,
        isLaborTimeGuideLoading: false,
      };
    case UPDATE_FAMILIES:
      return {
        ...state,
        families: action.families,
      };
    case UPDATE_PRODUCTNAMES:
      return {
        ...state,
        productNames: action.productNames,
      };
    case UPDATE_PRODUCTMODELS:
      return {
        ...state,
        productModels: action.productModels,
      };
    case LOAD_LABORTIMEGUIDE:
      return {
        ...state,
        isLaborTimeGuideLoading: true,
        serialNumber: action.serialNumber,
        selectedFamily: undefined,
        selectedProductName: undefined,
        selectedProductModel: undefined,
        selectedLaborTimeGuide: undefined,
      };
    case UPDATE_SERIAL_NUMBER:
      return {
        ...state,
        serialNumber: action.serialNumber,
      };
    case STOP_LOADING:
      return {
        ...state,
        isLaborTimeGuideLoading: false,
      };
    case CLEAR_VIEW_LABORTIMEGUIDE_STORE: {
      return initialState;
    }
    case CLEAR_LABORTIMEGUIDES_LIST:
      return {
        ...state,
        labortimeguideData: undefined,
      };
  }

  return state;
};
